import React, { useState, useEffect } from 'react';
import { MainLayout } from '@design-system/Layout';
import { Container, LinkBox } from './style';
import Summary from './components/summary';
import PickupAddress from './components/pickupAddress';
import { useDispatch, useSelector } from 'react-redux';
import { getAddress, getCreating } from './redux/selectors';
import { get_address, pay_for_basket } from './redux/reducer';
import Address from './components/address';
import { useParams } from 'react-router-dom';
import {
  apply_coupon,
  get_customer_basket,
  get_delivery_location,
  get_partner_config,
  get_user_products,
} from '@app/basket/redux/reducer';
import {
  getBasket,
  getCoupon,
  getCouponValue,
  getDeliveryLocations,
  getIsCarDelivery,
  getPartnerConfig,
  getProductsInBasket,
  getTotalPriceOfBasket,
} from '@app/basket/redux/selectors';
import LoadingScreen from './components/loadingScreen';
import { getDeliveryLocation } from '@app/product/redux/selectors';
import { get_location } from '@app/product/redux/reducer';
import { Link } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';

const BasketCart = () => {
  const [selected, setSelected] = useState(0);
  const dispatch = useDispatch();
  const address = useSelector(getAddress);
  const params = useParams();
  const products = useSelector(getProductsInBasket);
  const totalPrice = useSelector(getTotalPriceOfBasket);
  const partner_config = useSelector(getPartnerConfig);
  const locations = useSelector(getDeliveryLocations);
  const isCarDelivery = useSelector(getIsCarDelivery);
  const [pick_up, setPickUp] = useState([]);
  const [available_days, setAvailable] = useState([]);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [serviceFee, setServiceFee] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const [couponcode, setCouponCode] = useState('');
  const couponDetails = useSelector(getCoupon);
  const couponValue = useSelector(getCouponValue);
  const [deliveryETA, setDeliveryETA] = useState('');
  const basket = useSelector(getBasket);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [deliveryType, setDeliveryType] = useState('delivery');
  const [deliveryError, setDeliveryFeeError] = useState('');
  const [selected_pickupday, setPickupDay] = useState('');
  const [error, setError] = useState({ address: 'Select a delivery address' });
  const [deliveryNote, setDeliveryNote] = useState('');
  const [pickupNote, setPickupNote] = useState('');
  const creating = useSelector(getCreating);
  const delivery_location = useSelector(getDeliveryLocation);

  useEffect(() => {
    if (selectedAddress?._id) {
      setError();
    } else {
      setError({ address: 'Select a delivery address' });
    }
  }, [selectedAddress]);

  useEffect(() => {
    if (basket.partner?._id) {
      dispatch(
        get_delivery_location({
          id: basket.partner?._id,
          page: 1,
        }),
      );
    }
  }, [dispatch, basket]);

  useEffect(() => {
    dispatch(get_address());
    dispatch(get_location());
  }, [dispatch]);

  useEffect(() => {
    if (basket.partner?._id) {
      dispatch(get_partner_config(basket.partner?._id));
      // remove after moving to redux
      localStorage.setItem('partner_id', basket.partner?._id);
    }
  }, [dispatch, basket]);

  useEffect(() => {
    dispatch(get_user_products(params.id));
    dispatch(get_customer_basket(params.id));
  }, [dispatch, params]);

  useEffect(() => {
    if (partner_config.is_pickup) {
      let pickup_keys = Object.keys(partner_config?.pickup_days);
      pickup_keys.map((day) => {
        if (partner_config?.pickup_days?.[day]?.available) {
          setAvailable((prev) => [
            ...prev,
            day.charAt(0).toUpperCase() + day.slice(1),
          ]);
          setPickUp((prev) => [
            ...prev,
            {
              day: day.charAt(0).toUpperCase() + day.slice(1),
              from: partner_config?.pickup_days?.[day]?.from,
              to: partner_config?.pickup_days?.[day]?.to,
            },
          ]);
        }
      });
    }
  }, [partner_config]);

  const handleCoupon = (e) => {
    setCouponCode(e.target.value);
  };

  const applyCoupon = () => {
    let data = {
      coupon_code: couponcode,
      basket: params?.id,
    };
    dispatch(apply_coupon(data));
  };

  const calculateServiceFee = () => {
    // 2% service charge for users
    let service_fee = 0;
    const totalToPay = totalPrice.total_price + deliveryFee - couponValue;
    const applicableFees = 0.015 * totalToPay + 100;
    const cappedFees = 2000;
    let totalPaystackFees = applicableFees;
    if (applicableFees > cappedFees) {
      totalPaystackFees = cappedFees;
    } else {
      totalPaystackFees = (totalToPay + 100) / (1 - 0.015) + 0.01 - totalToPay;
    }
    const subTotal =
      totalPrice.total_price + deliveryFee + couponValue + totalPaystackFees;
    service_fee += totalPaystackFees;
    setSubTotal(Math.round(subTotal));
    setServiceFee(Math.round(service_fee));
  };

  useEffect(() => {
    calculateServiceFee();
  }, [totalPrice, couponValue, deliveryFee, deliveryETA]);

  useEffect(() => {
    calculateDeliveryFee({ delivery: delivery_location, basket });
  }, [delivery_location, deliveryType, basket, selectedAddress]);

  const calculateDeliveryFee = ({ delivery, basket }) => {
    const partnerCountry = basket?.partner?.country;
    const selectedAddressCountry = delivery?.country;
    if (partnerCountry === 'Nigeria' && selectedAddressCountry === 'Nigeria') {
      const selectedDeliveryLocation = locations?.find(
        (location) => location.location === delivery.location,
      );

      if (deliveryType === 'delivery') {
        if (selectedDeliveryLocation) {
          if (isCarDelivery) {
            setDeliveryFee(selectedDeliveryLocation?.price_car?.value);
          } else {
            setDeliveryFee(selectedDeliveryLocation?.price_bike?.value);
          }
          setDeliveryFeeError('');
        } else {
          setDeliveryFee(0);
          setDeliveryETA('');
          setDeliveryFeeError('Delivery not available in your selected location');
        }
      } else {
        setDeliveryFee(0);
      }
    } else {
      setDeliveryFee(0);
      if (deliveryType === 'delivery') {
        setDeliveryFeeError('Delivery not available in your selected location');
      }
    }
  };

  const canCheckout = () => {
    // if product country is Nigeria, check if address is in Nigeria and in delivery location

    const partnerCountry = basket?.partner?.country;
    const selectedAddressCountry = selectedAddress?.country;

    if (deliveryFee === 0 && deliveryType === 'pick-up' && selected_pickupday) {
      return false;
    }

    if (partnerCountry !== selectedAddressCountry) {
      return true;
    }

    if (deliveryFee > 0) {
      return false;
    }

    if (couponValue > totalPrice.total_price) {
      return true;
    }

    return true;
  };

  const updateDeliveryMethod = (type) => {
    setDeliveryType(type);
    setDeliveryFee(0);
    setDeliveryFeeError('');
  };

  const handlePickupDay = (date) => {
    setPickupDay(date);
  };

  const tabs = [
    {
      title: 'home delivery',
      sub: 'Deliver products to address',
      value: 'delivery',
    },
    {
      title: 'pickup',
      sub: 'Pickup products from the sellers’s store',
      value: 'pick-up',
    },
  ];

  const toggleSelected = (item) => {
    setSelectedAddress(item);
  };

  const handleSubmit = (res) => {
    let data = {
      basket: basket?._id,
      reference: res?.reference,
      delivery_address: selectedAddress?._id,
      coupon: couponDetails?._id || undefined,
      delivery_fee: deliveryFee,
      pickup_date: selected_pickupday || undefined,
      delivery_note: deliveryNote || pickupNote || undefined,
    };

    dispatch(pay_for_basket(data));
  };

  const handleDeliveryNote = (doc) => {
    setDeliveryNote(doc);
  };

  const handlePickupNote = (doc) => {
    setPickupNote(doc);
  };

  const steps = [
    <Address
      key={selected}
      address={address}
      toggleSelected={toggleSelected}
      selectedAddress={selectedAddress}
      handleDeliveryNote={handleDeliveryNote}
      error={error}
      location={delivery_location}
      delivery_note={deliveryNote}
      locations={locations}
      deliveryFee={deliveryFee}
    />,
    <PickupAddress
      key={selected}
      handlePickupNote={handlePickupNote}
      partner_address={
        basket?.partner
          ? `${basket?.partner?.street_address || ''} ${
              basket?.partner?.city || ''
            } ${basket?.partner?.state || ''}`
          : '-'
      }
      pickup_days={pick_up}
      available_days={available_days}
      handlePickupDay={handlePickupDay}
      selected_pickupday={selected_pickupday}
    />,
  ];
  return (
    <MainLayout>
      <LinkBox>
        <Link
          to="/basket"
          style={{
            textDecoration: 'none',
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            color: '#333333',
            margin: 0,
          }}
        >
          <BiArrowBack />
          <p style={{ margin: '0' }}>Back</p>
        </Link>
      </LinkBox>

      <Container>
        <LoadingScreen isOpen={creating} />
        <div className="shipping">
          {/* shiiping method */}
          <div className="method">
            <div className="header">shipping method</div>
            <div className="body">
              {tabs.map((data, index) => (
                <div
                  className="tabs"
                  key={index}
                  onClick={() => {
                    setSelected(index);
                    updateDeliveryMethod(data.value);
                  }}
                >
                  <div style={{ display: 'inline-block' }}>
                    <div className="tab-selected">
                      {selected === index && <div className="inner" />}
                    </div>
                  </div>
                  <div>
                    <h4>{data.title}</h4>
                    <h5>{data.sub}</h5>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* shiiping method end */}

          {/* address */}

          <div>{steps[selected]}</div>

          {/* address end*/}
        </div>

        <div className="summary">
          <Summary
            cart={products}
            applyCoupon={applyCoupon}
            handleCoupon={handleCoupon}
            totalPrice={totalPrice}
            subtotal={subtotal}
            serviceFee={serviceFee}
            deliveryFee={deliveryFee}
            couponValue={couponValue}
            handleSubmit={handleSubmit}
            error={deliveryError}
            canCheckout={canCheckout}
            creating={creating}
          />
        </div>
      </Container>
    </MainLayout>
  );
};

export default BasketCart;
